import React from 'react';
import './ScheduleRowTitle.less';

export const ScheduleRowTitle = ({text}) => {
	return <span className="schedule-row-title">{text}</span>
}
